export default __webpack_public_path__ + "9c77edfc0c178b6437441eab0b08e703.png";